import { render, staticRenderFns } from "./ViewLangSelect.vue?vue&type=template&id=0c7cbcf2"
import script from "./ViewLangSelect.vue?vue&type=script&lang=js"
export * from "./ViewLangSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports